import React, { useState } from "react";
import './Admin.css';
import RTEditor from '../../utils/RTEditor';
import {saveConferenceInfo } from "../../services/ConferenceInformation";
import Alert, { AlertColor } from "@mui/material/Alert";
import CheckIcon from "@mui/icons-material/Check";
import ErrorIcon from "@mui/icons-material/Error";

export default function ConferenceDescription({ conferenceInfo, onConferenceInfoUpdate }: { conferenceInfo: any, onConferenceInfoUpdate: () => void }) {
  const [isShowAlert, setShowAlert] = useState(false);
  const [alertType, setAlertType] = useState<AlertColor>('success');
  const [alertMessage, setAlertMessage] = useState('');
  const handleSave = async (editorContent: string) => {
      if (conferenceInfo?.Description !== editorContent) {
        if(conferenceInfo!==undefined){
            conferenceInfo.Description=editorContent;
            try {
            await saveConferenceInfo(conferenceInfo);
            onConferenceInfoUpdate();
            setAlertType('success');
            setAlertMessage('Conference Description successfully submitted.');
            setShowAlert(true);
          } catch (error) {
            setAlertType('error');
            setAlertMessage('Failed to submit Conference Description. Please try again.');
            setShowAlert(true);
          } finally {
            setTimeout(() => {
              setShowAlert(false);
            }, 5000);
          }
        }
      }
    };
    return (
      <div className="Margin">
      {isShowAlert && (
        <Alert icon={alertType === 'success' ? <CheckIcon fontSize="inherit" /> : <ErrorIcon fontSize="inherit" />} severity={alertType}>
          {alertMessage}
        </Alert>
      )}
        <div className="EditorContainer">
          <RTEditor editorName={"Conference Description"} 
          content={conferenceInfo?.Description} 
          saveContent={handleSave} />
        </div>
      </div>
    );
}
